import { createSelector } from 'reselect';
import { IAppState } from '../../../AppModulesWrapper';
import { selectIsSubagent } from '../../reducers/v2/user/selectors';
import { selectPlacingMoneySource } from '../../reducers/v2/moneySources/selectors';
import { selectIsInsufficientFunds } from '../checkoutInfo';
import { masterHasNotEnoughMoney } from './utils/masterHasNotEnoughMoney';

export const selectMasterHasNotEnoughMoney = createSelector(
  [
    (state: IAppState) => selectIsSubagent(state),
    (state: IAppState) => selectPlacingMoneySource(state),
    (state: IAppState) => selectIsInsufficientFunds(state),
  ],
  (isSubagent, selectedMoneySource, isInsufficientFunds) => {
    return masterHasNotEnoughMoney({
      isSubagent,
      selectedMoneySource,
      isInsufficientFunds,
    });
  },
);
